import styled from 'styled-components';
import {dFlexColumn} from '../../../../../../globalVariables/GlobalFlex';

export const explainContent = styled.div`
    ${dFlexColumn}
    gap: var(--space-xl);
    text-align: start;
    padding-inline: var(--space-2xl);
    padding-block-end: var(--space-2xl);
`;

export const explainTitle = styled.h2`
    margin: 0; /* reset browser default h2 margin */
    font-size: var(--font-size-heading-page);
    font-weight: var(--font-weight-semibold);
    line-height: 1.2;
`;

export const explainIntro = styled.div`
    font-size: var(--font-size-heading-modal);
    font-weight: var(--font-weight-regular);
    line-height: 1.4;
`;

export const explainLayers = styled.div`
    ${dFlexColumn}
    gap: var(--space-sm);
`;

export const explainLine = styled.div`
    font-size: var(--font-size-heading-modal);
    font-weight: var(--font-weight-regular);
    line-height: 1.4;
    b{
        font-weight: var(--font-weight-bold);
    }
`;
